import * as Sentry from "@sentry/react";
import { Suspense } from "react";
import { Route, Navigate, Routes } from "react-router";
import { MenuOptionsConfig } from "../MenuOptions";
import { Loading } from "../../../components";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export const RightSide = () => {
  return (
    <div className="flex-fill right-side-panel">
      <div className="w-100 options-container">
        <Suspense
          fallback={
            <div className="col-12 item-list-loading text-center h-100">
              <Loading size={120} />
            </div>
          }
        >
          <SentryRoutes>
            {MenuOptionsConfig.map((x) => (
              <Route key={x.path} path={x.path} element={x.component} />
            ))}
            <Route path="*" element={<Navigate to="/robots" />} />
          </SentryRoutes>
        </Suspense>
      </div>
    </div>
  );
};
